// components/Loader.js
import React from 'react';

const Loader = () => (
  <div className="flex justify-center items-center h-64">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#DABA60]"></div>
  </div>
);

export default Loader;
